import React from 'react';
import { get } from 'lodash';

import { Field } from 'redux-form';

import Grid from '@material-ui/core/Grid';
import TextField from 'components/fields/TextField';
import AutosuggestField from 'components/fields/AutosuggestField';
import OrderInformationSection from 'components/workflow/OrderInformation/OrderInformationSection';
import OrderInformationSectionTitle from 'components/workflow/OrderInformation/OrderInformationSectionTitle';

import * as validate from 'utils/validate';

const resubmissionCodes = ['1', '7', '8'];

const OrderInformationResubmission = (props) => {
  const insurancesField = get(props, 'Insurances');
  return (
    <OrderInformationSection>
      <Grid
        item
        xs={12}
      >
        <OrderInformationSectionTitle title="Resubmission Code & Reference" />
        <Grid
          container
          justify="flex-start"
          wrap="nowrap"
          spacing={16}
        >
          <Grid item xs={5}>
            <Field
              id="Resubmission"
              name="Resubmission"
              component={AutosuggestField}
              placeholder="-Code-"
              fullWidth
              renderSuggestionContent={suggestion => suggestion}
              onSuggestionSelected={suggestion => suggestion}
              fetchSuggestions={({ value }) => (new Promise((resolve) => {
                if (value.length > 0) {
                  resolve(resubmissionCodes
                    .filter(item => item.toLowerCase().indexOf(value.toLowerCase()) !== -1));
                } else {
                  resolve(resubmissionCodes);
                }
              }))}
              disabled={(insurancesField.input.value[0]
                && insurancesField.input.value[0].type === 'Self') || props.disabled}
              validate={validate.resubmissionCode}
            />
          </Grid>
          <Grid item xs={7}>
            <Field
              id="Original Ref Number"
              name="Original Ref Number"
              component={TextField}
              placeholder="-Reference-"
              disabled={(insurancesField.input.value[0]
                && insurancesField.input.value[0].type === 'Self') || props.disabled}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </OrderInformationSection>
  );
};

export default OrderInformationResubmission;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationResubmission/OrderInformationResubmission.js